export const SWING_CONTRACTS = '/api/SwingContract';
export const GET_CONTRACT_TYPE = '/api/SwingContract/Types/0/0';
export const GET_CONTRACT_LOCATIONS = '/api/SwingContract/Locations';
export const GET_POWER_AUTOMATE_TAGS = '/api/Cva/PowerAutomateMappingTags';

export const MESSAGES = {
  CONTRACT_CREATED: 'Contract created successfully!',
  SUB_CONTRACT_CREATED: 'Subcontract created successfully!',
  CONTRACT_DELETED: 'Contract deleted successfully!',
  SUB_CONTRACT_DELETED: 'Subcontract deleted successfully!',
  CONTRACT_UPDATED: 'Contract details updated successfully!',
  SUB_CONTRACT_UPDATED: 'Subcontract details updated successfully!',
  REQUIRED_COUNTERPARTY: 'Counterparty is required!',
  REQUIRED_TYPE: 'Type is requires!',
  REQUIRED_NAME: 'Contract Reference is required!',
  REQUIRED_POWER_AUTOMATE_TAG: 'Mapping tag is required!',
  LOCATION_DATE_MISMATCHED:
    "Contract start date should match any of the location's start dates, and contract end date should match any of the location's end dates.",
  CONTRACT_DATE_OUTSIDE_RANGE:
    'The contract start and end dates are outside the range of the locations. Please update the locations dates first.',
  CONFIRM_DELETE_CONTRACT: 'Are you sure you want to delete this contract?',
  CONFIRM_DELETE_SUB_CONTRACT:
    'Are you sure you want to delete this subcontract?',
  CONFIRM_DELETE_CONTRACTS:
    'Are you sure you want to delete this contract and all subcontracts?',
  CONFIRM_CONTRACT_CHANGES_UNSAVED:
    'You have unsaved changes on the current contract details. If you proceed to load another contract, all unsaved changes will be lost.',
  LOCATIONS_DATE_OVERLAPPED:
    'The dates must be consecutive without any gaps or overlaps.',
  SUB_CONTRACT_DATE_MISMATCHED:
    "Contract start date should match any of the subcontract's start dates, and contract end date should match any of the subcontract's end dates.",
};

export const ACTUAL_AT_MASTER_LEVEL = {
  locations: 'Locations must be added against the sub contracts.',
  cva: 'CVA Reference should be added for the sub contracts.',
};
